import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Divider, Grid, Typography } from "@material-ui/core";
import fontConfig from "../../constants/fonts";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
  icon: {
    height: "30vh",
  },
  gridContainer: {
    // backgroundColor: "red",
    height: "100%",
    // padding: "3vh",
  },
  title: {
    ...fontConfig.bold,
    fontSize: "2.5rem",
    color: theme.palette.primary.main,
    // fontFamily: ,
    textTransform: "uppercase",
    letterSpacing: "0.1rem",
    // backgroundColor: theme.palette.primary.main,
    borderRadius: 100,
    // boxShadow: "5px 5px 20px rgba(0,0,0,0.2)",
    // width: "20%",
    // width: "15%",
    textAlign: "center",
    padding: "0px 0px 20px 0px",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.2rem",
      textAlign: "center",
      letterSpacing: "0.05rem",
    },
  },
  divider: {
    backgroundColor: theme.palette.secondary.main,
    height: theme.spacing(0.5),
    borderRadius: 100,
    [theme.breakpoints.down("md")]: {
      height: theme.spacing(0.2),
    },
  },
}));

const TitleContainer = (props) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h4" align="center" className={classes.title}>
        {props.title}
      </Typography>
      <Divider className={classes.divider} />
    </>
  );
};
export default TitleContainer;
